
import React from "react";
import { 
  UserPlusIcon, 
  CalendarPlus
} from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ActionButtonProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick?: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({ 
  icon, title, description, onClick 
}) => {
  return (
    <button
      onClick={onClick}
      className="flex items-start p-4 rounded-xl bg-card border border-border/40 hover:border-primary/30 hover:bg-accent/30 transition-all text-left animate-enter-up shadow-subtle hover:shadow-elevated w-full mb-4"
    >
      <div className="flex-shrink-0 mr-4 p-3 rounded-lg bg-primary/10 text-primary">
        {icon}
      </div>
      <div>
        <h3 className="font-medium text-foreground mb-1">{title}</h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </button>
  );
};

interface ActionPanelProps {
  onAction?: (action: string) => void;
}

const ActionPanel: React.FC<ActionPanelProps> = ({ onAction }) => {
  const navigate = useNavigate();

  const handleAction = (action: string) => {
    if (action === "findGuest") {
      navigate("/explore");
    } else if (action === "scheduleRecording") {
      navigate("/calendar");
    } else if (onAction) {
      onAction(action);
    }
  };

  return (
    <div className="space-y-4 animate-enter">
      <ActionButton
        icon={<UserPlusIcon className="w-5 h-5" />}
        title="Find New Guest"
        description="Discover potential guests based on your podcast topics"
        onClick={() => handleAction("findGuest")}
      />
      <ActionButton
        icon={<CalendarPlus className="w-5 h-5" />}
        title="Schedule Recording"
        description="Set up recording sessions with your upcoming guests"
        onClick={() => handleAction("scheduleRecording")}
      />
    </div>
  );
};

export default ActionPanel;
